const { instance } = require('./url')
const {downloadPDF} = require('./pdf')

/**
 * @param {Quote} quote
 */
function openEmailApplication(quote, email) {
    downloadPDF(quote, true, true)

    const link = 'mailto:' + encodeURIComponent(email.toEmail) +
        '?subject=' + encodeURIComponent(email.subject) +
        '&cc=' + encodeURIComponent(email.ccEmail) +
        '&body=' + encodeURIComponent(email.body)

    document.location = link
}

async function sendEmail(quote, emailModel) {
    return await instance.post('/email', {
        'quote': quote,
        'email': emailModel,
    })
}

export {
    sendEmail,
    openEmailApplication,
}


